<template>
  <div :class="classes">
    <common-header-skeleton v-if="status === 'loading'" :is-small-widget-container-size="props.isSmallWidgetContainerSize" :mode="mode" />

    <template v-if="status === 'success'">
      <!-- HOME TEAM -->
      <team-section
        :team="headerDataMemo.home"
        team-qualifier="homeTeam"
        :is-small-widget-container-size="props.isSmallWidgetContainerSize"
        :mode="props.mode"
        direction="reversed"
      />

      <!-- UPCOMING EVENT HEADER MODE -->
      <upcoming-event-section
        v-if="headerDataMemo.upcomingEventStartTime.isUpcoming"
        :date="headerDataMemo.upcomingEventStartTime.date"
        :time="headerDataMemo.upcomingEventStartTime.time"
        :is-small-widget-container-size="props.isSmallWidgetContainerSize"
      />

      <!-- LIVE/FINISHED EVENT HEADER MODE -->
      <base-event-section
        v-else
        :home-score="headerDataMemo.home.score"
        :away-score="headerDataMemo.away.score"
        :match-status="headerDataMemo.matchStatus"
        :is-small-widget-container-size="props.isSmallWidgetContainerSize"
      />

      <!-- AWAY TEAM -->
      <team-section :team="headerDataMemo.away" team-qualifier="awayTeam" :is-small-widget-container-size="props.isSmallWidgetContainerSize" :mode="props.mode" />
    </template>
  </div>
</template>

<script setup>
import { computed, inject } from 'vue'
import TeamSection from './sections/TeamSection.vue'
import UpcomingEventSection from './sections/UpcomingEventSection.vue'
import BaseEventSection from './sections/BaseEventSection.vue'
import CommonHeaderSkeleton from './CommonHeaderSkeleton.vue'
import { adjustUpcomingEventTime, obtainMatchStatus } from './CommonHeader.helpers'

/** @type {{ mode: banner | regular | no-underline }} */
const props = defineProps({
  initialData: {
    type: Object,
    required: true
  },
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: false
  },
  mode: {
    type: String,
    default: 'regular'
  }
})

const status = inject('status')

const headerDataMemo = computed(() =>
  status.value === 'success'
    ? {
        ...(props.initialData?.headerData || {}),
        matchStatus: obtainMatchStatus(props.initialData),
        upcomingEventStartTime: adjustUpcomingEventTime(props.initialData?.startTime)
      }
    : {}
)

const classes = computed(() => [
  'szw-flex szw-p-2 szw-justify-center szw-rounded-lg w-full',
  props.mode !== 'banner' ? 'szw-bg-color-primary szw-text-white' : 'szw-bg-section-static szw-text-text-icon-primary'
])
</script>
